$(document)
  .on(`click`, `.quiz__optionsItem`, function (e) {
    try {
      e.stopImmediatePropagation();
      const isSelected = $(this).hasClass(`selected`);
      const isSelectionTypeSingleOrMultiple = $(this).closest(`.quiz__options`).attr(`selection-type`);

      if (typeof isSelectionTypeSingleOrMultiple !== 'undefined' && isSelectionTypeSingleOrMultiple == 'single') {
        $(this).closest(`.quiz__options`).find(`.quiz__optionsItem`).removeClass(`selected`);
        $(this).addClass(`selected`);
      } else if (typeof isSelectionTypeSingleOrMultiple !== 'undefined' && isSelectionTypeSingleOrMultiple == 'multiple') {
        if (isSelected) {
          $(this).removeClass(`selected`);
        } else {
          $(this).addClass(`selected`);
        }
      }

      const getTotalSelected = $(this).closest(`.quiz__slide`).find(`.quiz__optionsWrap .quiz__optionsItem.selected`).length;

      if (getTotalSelected > 0) {
        $(this).closest(`.quiz__slide`).find(`.quiz__nextSlide`).addClass(`active`);
      } else {
        $(this).closest(`.quiz__slide`).find(`.quiz__nextSlide`).removeClass(`active`);
      }
    } catch (err) {
      console.log(`ERROR .quiz__optionsItem`, err.message);
    }
  })

  .on(`click`, `.quiz__nextSlide`, async function (e) {
    try {
      e.stopImmediatePropagation();
      const getCurrentQuestionNo = $(this).closest(`.quiz__slide`).attr(`question`) * 1;

      const isNextQuestionAvailable = $(`.quiz__slide[question="${getCurrentQuestionNo + 1}"]`).length;

      if (isNextQuestionAvailable > 0) {
        $(this).closest(`.quiz__slide`).fadeOut();

        $(this)
          .closest(`.quiz`)
          .find(`.quiz__stepper .quiz__currentStep`)
          .text(`${getCurrentQuestionNo + 1}`);
      } else {
        const getResults = [];
        let getTags = ``;
        let getCollections = ``;

        $(`.quiz .quiz__slide`).each(function (i) {
          const getType = $(this).attr(`type`);

          const selectedOptions = $(this).find(`.quiz__optionsWrap .quiz__optionsItem.selected`).length;

          const questionNumber = i + 1;

          const answers = [];

          if (getType == 'collection') {
            const getCollection = $(this).attr(`collection`);

            getCollections += `::${getCollection}`;
          } else {
            if (selectedOptions > 1) {
              $($(this).find(`.quiz__optionsWrap .quiz__optionsItem.selected`)).each(function () {
                const getR = $(this).text();

                answers.push(getR);

                getTags += `::${getR}`;
              });
            } else {
              const selectedOptionText = $(this).find(`.quiz__optionsWrap .quiz__optionsItem.selected`).text();

              answers.push(selectedOptionText);

              getTags += `::${selectedOptionText}`;
            }
          }

          const makeObj = { question: questionNumber, answers: answers };

          getResults.push(makeObj);
        });

        console.log('getResults', getResults);

        getSelectedTags = getTags.substring(2);

        console.log('selectedResults', getTags.substring(2));
        console.log('getCollections', getCollections.substring(2));

        const getResponse = await getRequest(`/pages/quiz-results?getTags=&getCollections=${getCollections.substring(2)}`);

        const getProducts = await addProductToQuiz(getResponse, 'collection');

        if (typeof getProducts !== 'undefined' && getProducts) {
          $(`.quiz__resultProducts`).html(getProducts);

          $(`.quiz__resultProducts .productCard`).each(function () {
            const getHandle = $(this).attr(`handle`);

            const isDuplicate = $(`.quiz__resultProducts .productCard[handle="${getHandle}"]`).length;

            if (isDuplicate > 1) {
              $(this).remove();
            }
          });
        } else {
          $(`.quiz__resultProducts`).text(`No Item Found`);
        }

        // console.log ( 'getResponse', getResponse );

        $(this).closest(`.quiz__slide`).fadeOut();

        $(this).closest(`.quiz`).find(`.quiz__slide .quiz__result`).addClass(`active`);

        $(this).closest(`.quiz`).find(`.quiz__stepper`).fadeOut();
      }

      const isLastSlide = $(this).closest(`.quiz__slide`).hasClass(`lastSlide`);

      if (isLastSlide) {
        $(`.quiz .quiz__slide[type]`).each(function (i) {
          const getType = $(this).attr(`type`);

          const questionIs = $(this).attr(`question-is`);

          const selectedOptions = $(this).find(`.quiz__optionsWrap .quiz__optionsItem.selected`).length;

          const questionNumber = i + 1;

          if (getType == 'collection') {
            const getCollection = $(this).attr(`collection`);

            if (typeof getCollection !== 'undefined' && getCollection) {
              extra_properties[`Question_${questionNumber}`] = questionIs;

              extra_properties[`Answer_${questionNumber}`] = getCollection;
            }
          } else if (getType == 'tag') {
            extra_properties[`Question_${questionNumber}`] = questionIs;

            if (selectedOptions > 1) {
              $($(this).find(`.quiz__optionsWrap .quiz__optionsItem.selected`)).each(function () {
                const getR = $(this).attr(`tag`);

                extra_properties[`Answer_${questionNumber}`] = getR;
              });
            } else {
              const selectedOptionText = $(this).find(`.quiz__optionsWrap .quiz__optionsItem.selected`).attr(`tag`);

              extra_properties[`Answer_${questionNumber}`] = selectedOptionText;
            }
          }

          console.log('extra_properties', extra_properties);
        });
      }
    } catch (err) {
      console.log(`ERROR .quiz__nextSlide`, err.message);
    }
  })

  .on(`click`, `.quiz__form__btn`, async function (e) {
    try {
      e.stopImmediatePropagation();

      const getResults = [];
      let getTags = ``;
      let getCollections = ``;

      $(this).closest(`.quiz__slide`).fadeOut();
      
      $(this).closest(`.quiz`).find(`.quiz__slide .quiz__result`).addClass(`active`);
      $(this).closest(`.quiz`).find(`.quiz__stepper`).fadeOut();

      const getTagResponse = await getRequest(`/search?q=tag:quiz-group&view=json`);

      if (typeof getTagResponse !== 'undefined' && getTagResponse) {
        getQuizProducts = getTagResponse;

        // console.log ( 'getTagResponse', getTagResponse );
      }

      $(`.quiz .quiz__slide[type]`).each(function (i) {
        const getType = $(this).attr(`type`);

        const selectedOptions = $(this).find(`.quiz__optionsWrap .quiz__optionsItem.selected`).length;

        const questionNumber = i + 1;

        const answers = [];

        if (getType == 'collection') {
          const getCollection = $(this).attr(`collection`);

          getCollections += `::${getCollection}`;
        } else if (getType == 'tag') {
          if (selectedOptions > 1) {
            $($(this).find(`.quiz__optionsWrap .quiz__optionsItem.selected`)).each(function () {
              const getR = $(this).attr(`tag`);

              answers.push(getR);

              getTags += `::${getR}`;
            });
          } else {
            const selectedOptionText = $(this).find(`.quiz__optionsWrap .quiz__optionsItem.selected`).attr(`tag`);

            answers.push(selectedOptionText);

            getTags += `::${selectedOptionText}`;
          }
        }

        const makeObj = { question: questionNumber, answers: answers };

        getResults.push(makeObj);
      });

      console.log('getResults', getResults);

      getSelectedTags = getTags.substring(2);

      console.log('selectedResults', getTags.substring(2));
      console.log('getCollections', getCollections.substring(2));

      const getResponse = await getRequest(`/pages/quiz-results?getTags=&getCollections=${getCollections.substring(2)}`);

      const getProducts = await addProductToQuiz(getResponse, 'collection');

      if (typeof getProducts !== 'undefined' && getProducts) {
        
        
        const isDecafSelected = $('[tag="quiz_decaf"]').hasClass('selected');
        const decafExclude = [
          9132243396,
          11540968527,
          6916540203194,
          6854961627322,
          9401065988,
          691472531484,
        ];


        const excludeFalse = (
          $('[tag="quiz_pour-over"]').hasClass('selected') 
          || $('[tag="quiz_aeropress"]').hasClass('selected')
          || $('[tag="quiz_filter-machine"]').hasClass('selected')
        );

        const excludeTrue = (
          $('[tag="quiz_espresso"]').hasClass('selected') 
          || $('[tag="quiz_mokapot"]').hasClass('selected')
        );
        
        

        
        $(`.quiz__resultProducts`).fadeOut('fast', function() {
          $(`.quiz__resultProducts`).html(getProducts);

          $(`.quiz__resultProducts .productCard`).each(function () {
            const getHandle = $(this).attr(`handle`);
            const isDuplicate = $(`.quiz__resultProducts .productCard[handle="${getHandle}"]`).length > 1;
            const pid = +$(this).attr('pid');
            
  
            if(isDecafSelected) {
              if( decaf_products.includes(pid) ) {
                $(this).remove();
              }
            }

            if(excludeTrue) {
              if( metafield_quiz[pid] == "true" ) {
                $(this).remove();
              }
            }
            
            if(excludeFalse) {
              if( metafield_quiz[pid] == "false" ) {
                $(this).remove();
              }
            }
  
            if(isDuplicate) {
              $(this).remove();
            }          
          });


          if( $('.quiz__resultProducts .productCard').length == 0 ) {
            $('.quiz__resultProducts').html( $('.quiz-no-items').html() );
          }

          setTimeout(function() {
            $(`.quiz__resultProducts`).fadeIn('slow');
          }, 100);
        });


      } else {
        $(`.quiz__resultProducts`).html( $('.quiz-no-items').html() );
      }

      // console.log ( 'getResponse', getResponse );

      

      
    } catch (err) {
      console.log(`ERROR .quiz__form__btn`, err.message);
    }
  })

  .on(`click`, `.quiz-modal__start`, async function (e) {
    try {
      e.stopImmediatePropagation();

      $('.quiz').removeClass('quiz--start');
      $(this).closest(`.quiz__titleScreen`).fadeOut();
    } catch (err) {
      console.log(`ERROR .quiz__titleScreen__grid__right--centerCenter`, err.message);
    }
  })

  .on(`click`, `.quiz-email__next`, function( e ) {
    try {
      e.preventDefault();
      e.stopImmediatePropagation();

      const getEmailVal   =   $( `#k_id_email` ).val();

      if ( getEmailVal != '' ) {

        $( `.klaviyo_submit_button` ).click();

      } else {

        $( `.quiz__form__btn` ).click();

      }

    }
    catch ( err ) {
      console.log( `ERROR .klaviyo_submit_button`, err.message );
    }
  })


  .on(`click`, `.quickView__centerCenter__close`, function (e) {
    try {
      e.stopImmediatePropagation();
      $(this).closest(`.quickView`).remove();
    } catch (err) {
      console.log(`ERROR .quickView__centerCenter__close`, err.message);
    }
  })

  .on(`change`, `.qv__optionsBlock__item .qv__optionsBlock__item--select`, async function (e) {
    try {
      e.stopImmediatePropagation();

      const card = $(`.quiz__resultProducts .productCard`);
      const PID = $(this).closest(`.quickView`).attr(`pid`);
      let getJson = card.find(`.jsonData[pid="${PID}"]`).val();

      if (typeof getJson !== 'undefined' && getJson) {
        getJson = JSON.parse(getJson);
      }

      let totalOptions = 0;
      let variants;

      if (typeof getJson.options !== 'undefined' && getJson.options) {
        totalOptions = getJson.options.length;
      }

      if (typeof getJson.variants !== 'undefined' && getJson.variants) {
        variants = getJson.variants;
      }

      console.log('variants', variants);
      console.log('totalOptions', totalOptions);

      let selectedVariant;

      if (totalOptions == 1) {
        const getFirstSelectVal = $(`.qv__optionsBlock__item[position="1"] select`).val();

        selectedVariant = findObjectByKey__(variants, 'title', getFirstSelectVal);
      } else if (totalOptions == 2) {
        const getFirstSelectVal = $(`.qv__optionsBlock__item[position="1"] select`).val();
        const getSecondSelectVal = $(`.qv__optionsBlock__item[position="2"] select`).val();

        // console.log ( 'getFirstSelectVal', getFirstSelectVal );
        // console.log ( 'getSecondSelectVal', getSecondSelectVal );

        selectedVariant = findObjectByKey__(variants, 'title', `${getFirstSelectVal} / ${getSecondSelectVal}`);

        // console.log ( 'selectedVariant', selectedVariant );
      } else if (totalOptions == 3) {
        const getFirstSelectVal = $(`.qv__optionsBlock__item[position="1"] select`).val();
        const getSecondSelectVal = $(`.qv__optionsBlock__item[position="2"] select`).val();
        const getThirdSelectVal = $(`.qv__optionsBlock__item[position="3"] select`).val();

        // console.log ( 'getFirstSelectVal', getFirstSelectVal );
        // console.log ( 'getSecondSelectVal', getSecondSelectVal );
        // console.log ( 'getThirdSelectVal', getThirdSelectVal );

        selectedVariant = findObjectByKey__(variants, 'title', `${getFirstSelectVal} / ${getSecondSelectVal} / ${getThirdSelectVal}`);
      } else {
      }

      if (typeof selectedVariant !== 'undefined' && selectedVariant) {
        $(`.qv__addToCartFeature .qv__btn span[price]`).html(`${currentSymbol}${selectedVariant.price / 100}`);

        $(`#quickView__selectedVariant`).val(selectedVariant.id);
      }
    } catch (err) {
      console.log(`ERROR .qv__optionsBlock__item--select`, err.message);
    }
  })

  .on(`click`, `.quiz__result--restartQuiz`, function (e) {
    try {
      e.stopImmediatePropagation();

      $(`.quiz__slide`).removeAttr(`style`).find(`.quiz__optionsItem`).removeClass(`selected`);

      $(`.quiz__slide .quiz__nextSlide`).removeClass(`active`);

      $(`.quiz__stepper`).removeAttr(`style`).find(`.quiz__currentStep`).text(`1`);
      
      $('.quiz__resultProducts').html( $('#quizLoader').html() );
      
    } catch (err) {
      console.log(`ERROR .quiz__result--restartQuiz`, err.message);
    }
  });

function findObjectByKey__(array, key, value) {
  try {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }

    return null;
  } catch (err) {
    console.log(`ERROR findObjectByKey`, err.message);
  }
}

async function quickView(this_) {
  try {
    let rtn = ``;

    const getTemplateHTML = $(`template[t="quickView"]`).html();

    rtn = getTemplateHTML;

    return rtn;
  } catch (err) {
    console.log(`ERROR `, err.message);
  }
}


/**
 * 
 * @param {string} template takes a string containing template's variables.
 * @param {json} product takes the shopify's product JSON.
 * @returns a parsed string with updated template values.
 */
function parseTemplate(template, product, type = 'product') {
  
  let parsed = '';
  
  /**
   * Defining our template words here, all capital:
   */
  let VID = '';
  let PRICE = '';
  let IS_SOLDOUT = '';
  let IMG = product.featured_image;
  
  let FLAVOUR_PROFILE = '<div class="space-17"></div>';
  

  if( type == 'product' ) {

    PRICE = `${currentSymbol}${ (product.price / 100).toFixed(2) }`;
    VID = product.variants[0].id;
  
  } else if ( type == 'collection' ) {

    PRICE = product.price;

  }


  if( product.available ) {
    if( product.price_varies ) {
      PRICE = `From ${PRICE}`;
    }
  } else {
    PRICE = 'Sold Out';
    IS_SOLDOUT = 'buy-buttons--sold-out';
  }


  if( metafield_json && metafield_json[product.id] ) {
    IMG = metafield_json[product.id];
  }

  

  /**
   * DELAYING IMPLEMENTATION OF {FLAVOUR_PROFILE} for now
   */
  if( typeof flavour_profiles !== 'undefined' && flavour_profiles[product.id] ) {
    FLAVOUR_PROFILE = `
      <div class="space-10"></div>
      <span class="featured-product__meta">${ flavour_profiles[product.id] }</span>
    `;
  }



  parsed = template
    .replaceAll('{JSON}', JSON.stringify(product))
    .replaceAll('{PID}', product.id)
    .replaceAll('{HANDLE}', product.handle)
    .replaceAll('{IMG}', IMG)
    .replaceAll('{URL}', `/products/${product.handle}`)
    .replaceAll('{TITLE}', product.title)
    .replaceAll('{VID}', VID)
    .replaceAll('{PRICE}', PRICE)
    .replaceAll('{IS_SOLDOUT}', IS_SOLDOUT)
    .replaceAll('{FLAVOUR_PROFILE}', FLAVOUR_PROFILE)

  return parsed;
}

async function addProductToQuiz(o, type = '') {

  let rtn = ``;
  const getTemplateHTML = $(`template[t="productCard"]`).html();

  if (typeof getQuizProducts !== 'undefined' && getQuizProducts.length > 0) {
    const answersArr = getSelectedTags.split(`::`);

    getQuizProducts.forEach((el) => {
      let isTagMatched = false;
      const isMatched = answersArr.filter((element) => el.tags.includes(element));
      
      if (typeof isMatched !== 'undefined' && isMatched.length > 0) {
        isTagMatched = true;
      }

      const getFirstVID = el.variants[0].id;

      if (el.available && isTagMatched) {
        rtn += parseTemplate(getTemplateHTML, el, 'product');
      }
    });
  }

  if (typeof o.collectionProducts !== 'undefined' && o.collectionProducts.length > 0 && type == 'collection') {
    o.collectionProducts.forEach((el) => {
      if (el.inventory_qty > 0) {
        rtn += parseTemplate(getTemplateHTML, el, 'collection');
      }
    });
  }

  return rtn;
}

async function getRequest(url) {
  try {
    let rtn;

    await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        // console.log ( 'data', data );
        rtn = data;
      });

    return rtn;
  } catch (err) {
    console.log('Error getRequest', err.message);
  }
}







$(function() {
  const startLinkTl = gsap.timeline({ repeat: -1 });
  startLinkTl.fromTo('.quiz-modal__start-text > h2', {
    x: 0,
  }, {
    x: '-90%',
    duration: 80,
    ease: 'none'
  });



  const quizTl = gsap.timeline({ paused: true });

  quizTl
    

    

    .fromTo('.quiz__overlay', {
      x: '100%',
    }, {
      x: 0,

      duration: 1.2,
      ease: 'power2.in'
    }, '<')

    .fromTo('.quiz-button', {
      x: 0,
    }, {
      x: '-100vw',
      duration: 1.2,
      ease: 'power2.in'
    }, '<')

    .fromTo('.quiz', {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      duration: .1,
    })

    .to('.quiz__overlay', {
      x: () => window.innerWidth < 479 ? '-100%' : '-50%',

      duration: 1,
      ease: 'power2.out'
    })
    .to('.quiz__overlay', {
      autoAlpha: 0,
    })

  
  
  quizTl.eventCallback('onReverseComplete', () => {
    $('.quiz-button').removeClass('active');
    $('.quiz').removeClass('active');
  })

  function closeQuiz() {
    quizTl.reverse();
  }
  function openQuiz() {
    $('.quiz-button').addClass('active');
    $('.quiz').addClass('active');
    quizTl.play();
  }


  $(document).on('click', '.quiz-button', function(e) {
    e.preventDefault();


    /**
     * helps with lazyloading images inside quiz
     */
    document.querySelectorAll('.quiz img[data-src]').forEach(el => {
      el.setAttribute('src', el.getAttribute('data-src'));
      el.removeAttribute('data-src');
    });

    $('.quiz').hasClass('active') ? closeQuiz() : openQuiz();
  })
  
  $(document).on('click', '.quiz__close', closeQuiz)


})

